import React from 'react'
import { Link } from 'react-router-dom';

export default function LatestRecipes(props) {

      const recipeData = props.data;

  return (
    <div className='row recipes'>
    <div className='col-5 latest-recipes'>
      Latest Recipes
    </div>
    <div className='col-7 gy-1'>
      <hr />
    </div>
    <div>
      {recipeData.map((recipe, index) => (
        <div className='row' key={index}>
          <div className='col-5 gy-4 imageContainer'>
          <Link to={`/recipe/${recipe.id}`}>
            <img src={recipe.image} alt={`Recipe ${index + 1}`} />
          </Link>
          </div>
          <div className='col-7 gy-4 latest-recipe-text'>
          <Link to={`/recipe/${recipe.id}`} className='anchorTag'>
            {recipe.title}
          </Link>
            <div className='date mt-3'>
              {recipe.date}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  )
}
